import { Box, FormikSelectInputNative } from '@palmetto/palmetto-components';
import { Field } from 'formik';
import { useMemo } from 'react';

import { ConstructionAdderType, ProgramType } from 'types';

import { useGetConstructionAddersQuery } from '../../../../services/pricing';
import { sortByLabel } from '../util';

const removeAdderOption = { label: 'x--Remove Adder--x', value: 'remove' };

export const BulkEditConsumerSolarAddersFormSection = () => {
  const { data: arbitrageBatteryAdders = [] } = useGetConstructionAddersQuery({
    type: ConstructionAdderType.arbitrageBattery,
    programType: ProgramType.consumerSolar,
  });

  const arbitrageBatteryOptions = useMemo(
    () => [
      removeAdderOption,
      ...arbitrageBatteryAdders.map((aba: any) => ({ label: aba.name, value: aba.id })).toSorted(sortByLabel),
    ],
    [arbitrageBatteryAdders],
  );

  return (
    <Box childGap="lg">
      <Field
        name="arbitrageBattery"
        id="arbitrageBattery"
        label="Arbitrage Battery"
        component={FormikSelectInputNative}
        options={arbitrageBatteryOptions}
      />
    </Box>
  );
};
